import { createTypes, createAction } from "lib/action";

const LOAD_SECTIONS = createTypes("sections", "load");
const SHOW_SECTION = createTypes("sections", "show");
const CREATE_SECTION = createTypes("sections", "create");
const UPDATE_SECTION = createTypes("sections", "update");
const DELETE_SECTION = createTypes("sections", "delete");

const loadSections = {
  request: (params, token) => createAction(LOAD_SECTIONS.REQUEST, { params, token }),
  success: data => createAction(LOAD_SECTIONS.SUCCESS, { data }),
  failure: err => createAction(LOAD_SECTIONS.FAILURE, { err }),
};

const showSection = {
  request: (id, token) => createAction(SHOW_SECTION.REQUEST, { id, token }),
  success: data => createAction(SHOW_SECTION.SUCCESS, { data }),
  failure: err => createAction(SHOW_SECTION.FAILURE, { err }),
};

const createSection = {
  request: (params, token) => createAction(CREATE_SECTION.REQUEST, { params, token }),
  success: data => createAction(CREATE_SECTION.SUCCESS, { data }),
  failure: err => createAction(CREATE_SECTION.FAILURE, { err }),
};

const updateSection = {
  request: (params, id, token) => createAction(UPDATE_SECTION.REQUEST, { params, id, token }),
  success: data => createAction(UPDATE_SECTION.SUCCESS, { data }),
  failure: err => createAction(UPDATE_SECTION.FAILURE, { err }),
};

const deleteSection = {
  request: (id, token) => createAction(DELETE_SECTION.REQUEST, { id, token }),
  success: id => createAction(DELETE_SECTION.SUCCESS, { id }),
  failure: err => createAction(DELETE_SECTION.FAILURE, { err }),
};

export {
  loadSections,
  showSection,
  createSection,
  updateSection,
  deleteSection,
  LOAD_SECTIONS,
  SHOW_SECTION,
  CREATE_SECTION,
  UPDATE_SECTION,
  DELETE_SECTION,
};
